import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useState,useEffect } from "react";
import sadminapi from '../api/sadminapi';
import loginapi from '../api/login';

function EditUser({ accessToken, setAccessToken, setRefreshFailed,pageOptions=[] }) {
  const navigate = useNavigate();
    const { user_name} = useParams();
  const handleGoBack = () => navigate(`/manageuser`);

  // -----------------------------
  // FORM STATE
  // -----------------------------

  const [currentUser,setCurrentUser]=useState(null);

  const [displayName, setDisplayName] = useState("");
  const [allowedPages, setAllowedPages] = useState([]);
  const [status, setStatus] = useState(false);
 

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");




  const [loading,setLoading]=useState(true);
  const [saving,setSaving]=useState(false);
  const [savingPassword,setSavingPassword]=useState(false);
  

 function setUserDetails(userDetails)
 {
    if(userDetails)
    {
         setDisplayName(userDetails.full_name);
      setAllowedPages(userDetails.allowed_pages);
      setStatus(userDetails.status==="active");
    }
    else{
      setDisplayName("");
      setAllowedPages([]);
      setStatus(false);
    }
    setCurrentUser(userDetails);
 }

  // -----------------------------
  // PASSWORD VALIDATION
  // -----------------------------
 

  const handlePasswordChange = (e) => {
  const v = e.target.value;
  setPassword(v);

  // Strong password regex:
  // At least 1 lowercase, 1 uppercase, 1 digit, 1 symbol, min length 6
  const strongPassRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/;

  if (v.trim().length === 0) {
    setPasswordError("");
    return;
  }

  if (v.length < 6) {
    setPasswordError("Password must be at least 6 characters.");
    return;
  }

  if (!strongPassRegex.test(v)) {
    setPasswordError(
      "Must contain 1 lowercase, 1 uppercase, 1 number, 1 symbol."
    );
    return;
  }

  setPasswordError("");
};


  // -----------------------------
  // HANDLE PAGE SELECTION
  // -----------------------------
  const togglePage = (p) => {
    setAllowedPages((prev) =>
      prev.includes(p) ? prev.filter((x) => x !== p) : [...prev, p]
    );
  };

  // -----------------------------
  // ENABLE SAVE ONLY IF VALID
  // -----------------------------
  const saveEnabled =
    displayName.trim() !== "";
  
  const passwordEnabled =
    password.trim() !== "" && passwordError.trim()==="";

  // -----------------------------
  // SAVE ACTION
  // -----------------------------
  const onSave = async () => {
   
    const txUser={
      displayName,
      user_name,
      allowed_pages: allowedPages,
      status: status ? "active" : "inactive",
    };

    setSaving(true);
            try{
              const response= await sadminapi.post('/updateUser',{txUser},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              alert(response.data.status);
              
                //setUsernameAvailable(response.data.isAvailbale);
            }
            catch(err)
            {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);
                
                const nat=x['data']['accessToken'];
                setAccessToken(nat);
                try{       
                 const response= await sadminapi.post('/updateUser',{txUser},{headers:{'Authorization':`Bearer ${nat}`}});    
                 alert(response.data.status);
                
                //setUsernameAvailable(response.data.isAvailbale);
                 }
                 catch(err)
                 {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  alert('unusual error newposts.js');
                 }
              }
              catch(err)
              {
                alert('failed');
              }
      
            }
            finally
            {
              setSaving(false);
            }
  };


  const onPasswordReset = async () => {
   
    const txUser={
     
      user_name,
     password
    };

    setSavingPassword(true);
            try{
              const response= await sadminapi.post('/updateUserPassword',{txUser},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              alert(response.data.status);
              
                //setUsernameAvailable(response.data.isAvailbale);
            }
            catch(err)
            {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);
                
                const nat=x['data']['accessToken'];
                setAccessToken(nat);
                try{       
                 const response= await sadminapi.post('/updateUserPassword',{txUser},{headers:{'Authorization':`Bearer ${nat}`}});    
                 alert(response.data.status);
                
                //setUsernameAvailable(response.data.isAvailbale);
                 }
                 catch(err)
                 {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  alert('unusual error newposts.js');
                 }
              }
              catch(err)
              {
                alert('failed');
              }
      
            }
            finally
            {
              setSavingPassword(false);
            }
  };
  

 const loadUserDetails =async()=>{
    setLoading(true);
    try{
              const response= await sadminapi.post('/loadUserProfile',{user_name},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              //alert(JSON.stringify(response.data.userDetails));
               setUserDetails(response.data.userDetails);
            }
            catch(err)
            {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);
                
                const nat=x['data']['accessToken'];
                setAccessToken(nat);
                try{       
                   const response= await sadminapi.post('/loadUserProfile',{user_name},{headers:{'Authorization':`Bearer ${nat}`}});    
              
               setUserDetails(response.data.userDetails);
                //setUsernameAvailable(response.data.isAvailbale);
                 }
                 catch(err)
                 {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  alert('unusual error newposts.js');
                 }
              }
              catch(err)
              {
                alert('failed');
              }
      
            }
            finally
            {
              setLoading(false);
            }
 }
  useEffect(()=>{
    
    loadUserDetails();
  },[]); 
  return (
    <main className="w-full">
      <div className="w-full bg-red-100 relative py-1">
        <button
          onClick={handleGoBack}
          className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition text-xs"
        >
          BACK
        </button>

        <h1 className="text-2xl text-gray-400 text-center">EDIT USER PROFILE</h1>
        <p className="w-full text-center font-semibold text-xs text-sm">({user_name})</p>
      </div>

      <div className="flex flex-col items-center justify-center w-full p-3">
       { !loading && currentUser && (<form className="w-full max-w-md bg-white shadow-md rounded-lg p-4">

          {/* DISPLAY NAME */}
          <label className="block font-semibold text-gray-600 text-sm mb-1">
            Display Name
          </label>
          <input
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="w-full p-2 border rounded-md text-sm"
            placeholder="User's name or branch"
          />
          {displayName.trim() === "" && (
            <p className="text-red-500 text-xs mt-1">Display name is required.</p>
          )}

          {/* USERNAME */}
          <label className="block font-semibold text-gray-600 text-sm mt-4 mb-1">
            Username
          </label>

          <div className="flex gap-2">
           <p>{user_name}</p>
          </div>

          



          

          {/* STATUS */}
          <div className="mt-4 flex items-center gap-2 ">
            <input
              type="checkbox"
              checked={status}
              onChange={() => setStatus(!status)}
              className="scale-150"
            />
            <span className="text-sm text-gray-600">
              Active (uncheck → inactive)
            </span>
          </div>

          {/* ALLOWED PAGES */}
          <label className="block font-semibold text-gray-600 text-sm mt-4 mb-1">
            Allowed Pages
          </label>

          <div className="grid grid-cols-1 gap-3  overflow-y-auto border p-2 rounded-md">
            {pageOptions.map((p) => (
              <label key={p} className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={allowedPages.includes(p)}
                  onChange={() => togglePage(p)}
                  className="scale-150"
                />
                {p}
              </label>
            ))}
          </div>

          {/* SAVE BUTTON */}
          <div className="flex justify-end mt-6">
            <button
              type="button"
              onClick={onSave}
              disabled={!saveEnabled}
              className={`px-4 py-2 rounded-md text-xs ${
                saveEnabled
                  ? "bg-blue-500 text-white hover:bg-blue-600"
                  : "bg-gray-300 text-gray-600"
              }`}
            >
              SAVE
            </button>
          </div>

        <div className="w-full p-2 bg-red-300 mt-4 mb-4 flex flex-col justify-center items-center">
  {/* PASSWORD */}
  <label className="block font-semibold text-gray-600 text-sm mt-4 mb-1">
    Password
  </label>

  <input
    type="text"
    value={password}
    onChange={handlePasswordChange}
    className="w-full p-2 border rounded-md text-sm"
    placeholder="min 6 chrs,lowercase, uppercase,number,symbol."
  />

  {passwordError && (
    <p className="text-red-500 text-xs mt-1">{passwordError}</p>
  )}

  <button
    type="button"
    onClick={onPasswordReset}
    disabled={!passwordEnabled}
    className={`px-4 py-2 rounded-md text-xs mt-2 ${
      passwordEnabled
        ? "bg-blue-500 text-white hover:bg-blue-600"
        : "bg-gray-300 text-gray-600"
    }`}
  >
    RESET PASSWORD
  </button>
</div>

        </form>)}
         { !loading && !currentUser && (
         <p className="text-center text-5xl">USER NOT FOUND!</p>)}
        {loading &&(<p className="text-center"> Please wait.....</p>)}
      </div>
    </main>
  );
}

export default EditUser;
